<template>
  <div class="item-info-content" v-if="table">
    <div class="item-info-title clear-fix">
      <div class="item-info-title-left">
        <div class="text">{{table.title1}}</div>
        <div class="number">{{parseFloat(table.realAmount).toFixed(2)}}元</div>
      </div>
      <div class="item-info-title-right">
        <div class="number">{{table.realCount}}</div>
        <div class="text">单</div>   
        <div class="item_rt"></div>   
      </div>
      <div class="bg_item" :style="{width:parseFloat(table.realAmount/totalPrice).toFixed(2) * 100 + '%',backgroundColor:table.color}"></div>  
    </div>
    <!-- <el-scrollbar ref="scrollbar" style="height: calc(100% - 88px)">
      <div class="item-info-body" v-if="table.list">
        <item v-for="(item,i) in table.list" :key="i">
          <div slot="leftTitle">{{item.goodsName}}</div>
          <div slot="leftNumber">{{parseFloat(item.goodsAmount).toFixed(2)}}</div>
          <div slot="rightTitle">{{item.goodsCountTitle}}</div>
          <div slot="rightNumber">{{item.goodsCount}}</div>
        </item>
      </div>
    </el-scrollbar> -->
  </div>
</template>

<script>
import Item from "./itemInfo/item.vue";
export default {
  props:{
    table:{
      type:Object,
      default: () => {
        return {}
      }
    },
    totalPrice:{
       type:Number,
       default:0
    },
  },
  components: {
    Item
  },
  created() {
    console.log(this.table);
  }
};
</script>

<style lang="scss" scoped>
.item-info-content {
  margin:0 10px;
  //width: calc(25% - 10px);
  // height: calc(100% - 10px);
  // border-radius: 4px;
  text-align: left;
  .item-info-title {
      position: relative;
      width: 100%;
      height: 40px;
      line-height: 40px;
      margin-top: 10px;
      border-radius: 4px 4px 0 0;
      background-color:#222120;
    cursor:pointer;
   .item_rt{
      margin-top:10px;
      float: right;
      border-width: 10px;
      border-style: solid;
      border-color: transparent #fff transparent transparent;
      transform: rotate(180deg); /*顺时针旋转90°*/
    }
    .text {
      padding-right: 10px;
      float: left;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 300;
      color: rgba(255, 255, 255, 1);
    }
    .number {
      float: left;
      font-size: 20px;
      font-family: Source Han Sans CN;
      //font-weight: 700;
      color: rgba(255, 255, 255, 1);
    }
    .bg_item{
      overflow: hidden;
      position:absolute;
      left:0px;
      top:0px;
      width:0%;
      height:100%;
    }
    .item-info-title-left {
      position: absolute;
      left:0px;
      top:0px;
      margin-left: 10px;
      float: left;  
      z-index: 10;  
    }
    .item-info-title-right {
      position: absolute;
      right:0px;
      top:0px;
      float: right;
      z-index: 10;
    }
  }
}
</style>